import { ApplicationRef, ChangeDetectionStrategy, ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnDestroy, OnInit, Signal, ViewChild } from '@angular/core';
import { BaseFeatureBannerComponent } from './base-feature-banner/base-feature-banner.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { CBaseComponent } from '../base/c-base.component';
import { ScreensizeStateService } from '../../../state-management/services/screensize-state.service';
import { CoordinatesSystem, ScreenWidthBreakpoints } from '../../../state-management/model/enums/screen-size.enums';

import { SwiperContainer } from 'swiper/element';
import { Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-c-feature-banner',
  imports: [
    BaseFeatureBannerComponent
  ],
  templateUrl: './c-feature-banner.component.html',
  styleUrl: './c-feature-banner.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CFeatureBannerComponent extends CBaseComponent implements OnInit, OnDestroy {
  @ViewChild('swiper') swiperEl!: ElementRef<SwiperContainer>;

  public isLargeScreen$: Signal<boolean> = this.screensizeState.isScreenSizes(CoordinatesSystem.ScreenWidth, [ScreenWidthBreakpoints.Large, ScreenWidthBreakpoints.XLarge]);
  private isStableSubject = new Subject<void>();

  constructor(private screensizeState: ScreensizeStateService, private appRef: ApplicationRef) {
    super();


    console.log('🚀 CFeatureBannerComponent.constructor()');
    this.appRef.isStable.pipe(takeUntil(this.isStableSubject)).subscribe((stable) => {
      console.log('App ist stabil: ', stable);
      if (stable) {
        console.log('✅ App ist jetzt stabil!');
        if (this.swiperEl) {
          this.swiperEl.nativeElement.swiper.params.autoplay = {
            delay: 5000,
            disableOnInteraction: false
          };
          this.swiperEl.nativeElement.swiper.update();
          this.swiperEl.nativeElement.swiper.autoplay.start();

        }
        this.isStableSubject.next();
        this.isStableSubject.complete();
      }
    });
  }

  ngOnDestroy(): void {
    this.isStableSubject.next();
    this.isStableSubject.complete();
  }

  override ngOnInit() {
    this.groupLabels = [ElementsType.FeatureBanner];
    super.ngOnInit();
  }
}